import {
  always,
  anyPass,
  concat, gt,
  ifElse,
  length,
  lt,
  objOf,
  path,
  pipe,
} from 'ramda'
import mergeRight from 'ramda/src/mergeRight'
import {stringify} from '../querySerializer'

export const selectWord = path(['createGame', 'word'])

const ifLengthGt1 = ifElse(pipe(length, lt(1)))

const toGameStateOb = pipe(objOf('word'), mergeRight({tries: []}))

const baseUrl = concat(window.location.origin, '/play?')

const buildUrl = pipe(toGameStateOb, stringify, concat(baseUrl))

const gameUrl = ifLengthGt1(buildUrl, always(''))

export const selectGameUrl = pipe(selectWord, gameUrl)

const isWordTooShort = pipe(length, gt(1))

export const selectShareDisabled = anyPass([
  path(['createGame', 'isSharing']),
  pipe(selectWord, isWordTooShort)
])
